<template>
  <CCard>
    <CCardBody>
      <h1>Maintenance</h1>

      <div>Service is unavailable due to ongoing maintenance.</div>
      <div>
        We apologize for any inconvenience caused and appreciate your patience.
      </div>

      <img
        src="/img/maintenance.svg"
        alt=""
        class="img-fluid mx-auto d-block mt-3"
        style="max-width: 50%"
      />
    </CCardBody>
  </CCard>
</template>

<script>
export default {
  name: "Maintenance",
};
</script>
